export const usagesByNames = /* GraphQL */ `
  query Usages($appNames: [String], $env: String) {
    usages(env: $env, names: $appNames) {
      name
      domain
      urls
    }
  }
`;
